export type BitmapPriceRange = { min: string; max: string }
export const BITMAP_PAGE_SIZE = 32
export function parseBitmapPrice(range: BitmapPriceRange, unit: 'sats' | 'BTC') {
	const factor = unit === 'BTC' ? 1e8 : 1
	const parse = (v: string) => (v.trim() === '' ? undefined : Number(v) * factor)
	const min = parse(range.min),
		max = parse(range.max)
	if (
		[min, max].some(
			(v) =>
				v !== undefined && (!Number.isFinite(v) || v < 0 || !Number.isSafeInteger(Math.round(v)))
		)
	)
		return { error: 'Enter a valid, non-negative price.' }
	if (min !== undefined && max !== undefined && min > max)
		return { error: 'From must be less than or equal to To.' }
	return {
		min: min === undefined ? undefined : Math.round(min),
		max: max === undefined ? undefined : Math.round(max)
	}
}
export function bitmapHeight(item: { name?: string; meta?: { name?: string } }) {
	const match = (item.meta?.name || item.name || '').match(/^(\d+)\.bitmap$/i)
	return match ? Number(match[1]) : null
}
export const BITMAP_TX_PRESETS = [
	{ value: '', label: 'Any layout', hint: 'All transaction counts' },
	{ value: '1', label: '1 tx', hint: 'Single-parcel blocks', traits: ['1'] },
	{ value: '10', label: '< 10 txs', hint: 'Minimal layouts', traits: ['1', 'sub10', '< 500'] },
	{
		value: '50',
		label: '< 50 txs',
		hint: 'Sparse layouts, verified against block data',
		traits: ['1', 'sub10', 'sub100', '< 500']
	},
	{
		value: '100',
		label: '< 100 txs',
		hint: 'Low-density layouts',
		traits: ['1', 'sub10', 'sub100', '< 500']
	}
] as const
export const BITMAP_PRICE_BANDS = [
	{ label: '< 20k', min: 0, max: 19999 },
	{ label: '20–50k', min: 20000, max: 49999 },
	{ label: '50–100k', min: 50000, max: 99999 },
	{ label: '100–500k', min: 100000, max: 499999 },
	{ label: '500k+', min: 500000, max: undefined }
]
